import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { TableQueryWrapper } from '@/components/TableQueryWrapper/TableQueryWrapper';
import { useAgreements } from '@/models/agreements';
import { Entity } from '@/models/entity';
import {
  AGREEMENTS_PER_PAGE,
  AgreementsTable,
} from '@/routes/SettingsBeta/components/AgreementsTable';

export const AgreementsSection = ({ entity }: { entity: Entity }) => {
  const { t } = useLingui();
  const [page, setPage] = useState(1);

  const {
    data: { agreements, meta } = { agreements: [] },
    isLoading,
    isPlaceholderData,
    isError,
  } = useAgreements(
    { limit: AGREEMENTS_PER_PAGE, offset: (page - 1) * AGREEMENTS_PER_PAGE, entityId: entity.id },
    { keepPreviousData: true }
  );

  return (
    <TableQueryWrapper isLoading={isLoading || !!isPlaceholderData} isError={isError}>
      <AgreementsTable
        agreements={agreements}
        page={page}
        onPageChange={setPage}
        count={meta?.count}
        emptyText={t({
          id: 'settings.organization.entities.agreements.table.empty.entity',
          message: 'No agreements on this entity.',
        })}
      />
    </TableQueryWrapper>
  );
};
